import { z } from 'zod';
import { userPublicSchema } from './user.js';
export const loginInputSchema = z.object({
    username: z.string().min(1).max(60),
    password: z.string().min(6).max(120),
});
export const meResponseSchema = z.object({
    user: userPublicSchema,
});
export const loginResponseSchema = z.object({
    user: userPublicSchema,
    token: z.string().min(1),
});
//# sourceMappingURL=auth.js.map